import React from "react";
import MarketingShell from "@/components/MarketingShell";
import { currentFullDate } from "@/utils/dates";

export default function Refund() {
  return (
    <MarketingShell>
      <div className="mkt-legal">
        <h1>Refund Policy</h1>
        <p className="mkt-legal-date" data-testid="legal-date-refund">
          Last updated: {currentFullDate()} &nbsp;|&nbsp; The Book Cot
        </p>

        <p>
          We want you to be completely satisfied with your purchase of any Viral Book
          Suite tool or service. This Refund Policy outlines the terms under which
          refunds may be issued by The Book Cot.
        </p>

        <h2>1. Digital Products — One-Time Purchases</h2>
        <p>
          Due to the digital nature of our tools and the immediate access granted upon
          purchase, all one-time tool purchases are subject to the following policy:
        </p>
        <ul>
          <li>We offer a <strong>14-day money-back guarantee</strong> from the date of purchase</li>
          <li>To request a refund within this period, contact us at <a href="mailto:hello@viralbooksuite.com">hello@viralbooksuite.com</a> with your order details and the reason for your request</li>
          <li>Refunds will be processed to your original payment method within 5–10 business days</li>
          <li>Refund requests made after 14 days of purchase will not be eligible, except where required by applicable consumer protection law</li>
        </ul>

        <h2>2. Subscriptions</h2>
        <p>For monthly or annual subscription plans:</p>
        <ul>
          <li>You may cancel your subscription at any time through your account dashboard</li>
          <li>Cancellation will take effect at the end of your current billing period — you will retain access until then</li>
          <li>We do not provide prorated refunds for unused portions of a subscription period, except where required by law</li>
          <li>If you experience a billing error, contact us immediately and we will investigate and correct it promptly</li>
        </ul>

        <h2>3. The Evergreen Monthly Income Cohort</h2>
        <p>For the Evergreen Monthly Income Cohort programme:</p>
        <ul>
          <li>A full refund is available within <strong>7 days of purchase</strong>, provided you have not attended more than one session</li>
          <li>After 7 days, or after attending two or more sessions, no refund will be issued</li>
          <li>If the cohort is cancelled by us for any reason, a full refund will be issued</li>
        </ul>

        <h2>4. Newsletter</h2>
        <p>
          The Evergreen Passive Monthly Income newsletter is offered free of charge.
          No payment is taken for newsletter access, so no refund policy applies.
        </p>

        <h2>5. Grounds for Refusal</h2>
        <p>We reserve the right to decline a refund request if:</p>
        <ul>
          <li>The request is made outside the applicable refund window</li>
          <li>There is evidence of misuse, abuse, or violation of our Terms of Service</li>
          <li>The refund request is made for the same product more than once</li>
          <li>The product has been used to generate and publish commercial content</li>
        </ul>

        <h2>6. UK Consumer Rights</h2>
        <p>
          Nothing in this Refund Policy affects your statutory rights under UK
          consumer protection law. If you are a consumer based in the United Kingdom,
          you may have additional rights under the Consumer Contracts Regulations 2013
          and the Consumer Rights Act 2015. For digital content, the right to cancel
          may not apply once you have expressly consented to access beginning during
          the 14-day cooling-off period.
        </p>

        <h2>7. How to Request a Refund</h2>
        <p>
          To request a refund, please email us at{" "}
          <a href="mailto:hello@viralbooksuite.com">hello@viralbooksuite.com</a> with
          the following information:
        </p>
        <ul>
          <li>Your full name and email address used for purchase</li>
          <li>The tool or service you purchased</li>
          <li>Your order or transaction reference number</li>
          <li>The reason for your refund request</li>
        </ul>
        <p>We will respond to all refund requests within 3 business days.</p>

        <h2>8. Contact</h2>
        <p>
          For any questions about this Refund Policy, please contact us at{" "}
          <a href="mailto:hello@viralbooksuite.com">hello@viralbooksuite.com</a>.
        </p>
      </div>
    </MarketingShell>
  );
}
